import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, sitConfig } from './config'

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const getRequest = (data: any) => {
  return {
    approvalId: Number(data.id),
    approvalType: data.approvalType,
    status: data?.approvalStatus?.toLowerCase() === 'true' ? true : false,
  }
}

const bulkEssProcessApprovals = (data: any, type: string, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath:
      type === 'RISK_TXN_CONTROLS'
        ? APIEndPoints.riskControlTxnProcessApproval
        : type === 'RISK_MERCHANT_CONTROLS'
        ? APIEndPoints.riskControlMerchantProcessApproval
        : APIEndPoints.payoutCmsProcessApproval,
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      ...getRequest(data),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { bulkEssProcessApprovals }
